import $http from '@/api';

const MONTH_URL_PARAM = '[month]';
const YEAR_URL_PARAM = '[year]';

export function fetchCalendarEvents(endpoint: string, year: number, month: number): Promise<{ color: string, events: array }> {
  if (!endpoint.includes(MONTH_URL_PARAM)) {
    console.error(`calendarEventsEndpoint prop needs a valid month url param [month] '${endpoint}'`);
    throw new Error();
  }
  if (!endpoint.includes(YEAR_URL_PARAM)) {
    console.error(`calendarEventsEndpoint prop needs a valid year url param [month] '${endpoint}'`);
    throw new Error();
  }
  return $http.get(endpoint.replace(MONTH_URL_PARAM, month.toString()).replace(YEAR_URL_PARAM, year.toString()));
}

export default {
  fetchCalendarEvents,
};
